// const observer_btn = new IntersectionObserver(entries => {
//   entries.forEach(entry => {
//       if(entry.isIntersecting){
//           document.querySelector('.product-sticky').classList.remove('active');
//       } else {
//           document.querySelector('.product-sticky').classList.add('active');
//       }
//   })
// });
  
// observer_btn.observe(document.querySelector('.product-form__action-wrapper'));

document.querySelectorAll('.template-product  [data-add-btn]').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const targetBtn = document.querySelector('.product-form__action-wrapper [data-product-atc]');
    
    if (targetBtn) {
      // Scroll to the button smoothly
      targetBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Simulate a click after a slight delay (to allow scroll animation)
      // setTimeout(() => {
      //   targetBtn.click();
      // }, 500);
    }
  });
});


document.querySelectorAll('.product-sticky [data-add-btn]').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const targetBtn = document.querySelector('.product-form__action-wrapper [data-product-atc]');
    
    if (targetBtn) {
      // Scroll to the button smoothly
      targetBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });

     
      setTimeout(() => {
        targetBtn.click();
      }, 500);
    }
  });
});

